import React from 'react';
import arrowLeftRSM from '../../../../assets/arrow-left-rsm.svg';
import arrowLeft from '../../../../assets/arrow-left.svg';
import arrowRightRSM from '../../../../assets/arrow-right-rsm.svg';
import arrowRight from '../../../../assets/arrow-right.svg';
import { isEnvRSM } from '../../../../common/utilities/_helpers';
import { InfinityIcon } from './InfinityIcon';

import { useResourceContext } from '../../../../common/resource-context';
import './Counter.scss';

interface CounterProps {
  onArrowLeft: () => void;
  onArrowRight: () => void;
  price: string;
  priceIncrement: string;
  currentRange: string;
  rangeTitle: string;
  disabled: { left: boolean; right: boolean };
  isCPAUpgrade?: boolean;
  isLeaseQueryPlan?: boolean;
}

export default function Counter({
  onArrowLeft,
  onArrowRight,
  price,
  priceIncrement,
  currentRange,
  rangeTitle,
  disabled,
  isCPAUpgrade,
  isLeaseQueryPlan,
}: CounterProps) {
  const isRSM = isEnvRSM();
  const resources = useResourceContext();

  const leftIcon = isRSM ? arrowLeftRSM : arrowLeft;
  const rightIcon = isRSM ? arrowRightRSM : arrowRight;

  const { left, right } = disabled;

  const hideBothOptions = left && right;

  return (
    <div className="main-display">
      {isLeaseQueryPlan ? (
        <div className="content-lease-query">
          <div>{resources.text('Counter_LeaseQuery_Content')}</div>
          <div>{resources.text('LeaseQuery')}</div>
        </div>
      ) : (
        <div className="content">
          <div className={'price' + (isCPAUpgrade ? ' cpa' : '')}>{price}</div>
          <div className="price-increment">{priceIncrement}</div>
        </div>
      )}

      <div className="counter">
        <button
          className="unset-button"
          onClick={onArrowLeft}
          type="button"
          disabled={left}
        >
          {!hideBothOptions && (
            <img
              src={leftIcon}
              alt="arrow-left"
              className={`arrow-button ${left && 'disabled'}`}
            />
          )}
        </button>
        {isLeaseQueryPlan ? (
          <InfinityIcon className="infinity-icon" />
        ) : (
          <div className="count-display">{currentRange}</div>
        )}
        <button
          className="unset-button"
          onClick={onArrowRight}
          type="button"
          disabled={right}
        >
          {!hideBothOptions && (
            <img
              src={rightIcon}
              alt="arrow-right"
              className={`arrow-button ${right && 'disabled'}`}
            />
          )}
        </button>
      </div>
      <div className="range-title">{rangeTitle}</div>
    </div>
  );
}
